/**
 * Navegação com sessão da plataforma (#430): confirmação ao sair / trocar.
 */
import { impersonate } from './api.js'
import { setToken } from './auth.js'
import {
  clearImpersonationSession,
  getImpersonationSession,
  isImpersonationActive,
} from './impersonation.js'

/** Destino de consola (fora de /r/:slug). */
export function isConsolePath(pathname: string): boolean {
  return !pathname.startsWith('/r/')
}

export type LeaveResult = 'ok' | 'cancelled' | 'stop_failed'

/**
 * Se há sessão ativa e o destino sai do restaurante da sessão, pede confirmação
 * e faz stop. Devolve 'ok' se a navegação pode seguir.
 */
export async function confirmLeaveImpersonation(
  targetSlug: string | null,
  t: (key: string, params?: Record<string, string>) => string,
): Promise<LeaveResult> {
  if (!isImpersonationActive()) return 'ok'
  const session = getImpersonationSession()
  if (!session) return 'ok'
  // Mesmo restaurante — ok
  if (targetSlug && targetSlug === session.tenant_slug) return 'ok'

  const ok = window.confirm(
    t('admin.impersonation.switch_confirm', { restaurant: session.tenant_name }),
  )
  if (!ok) return 'cancelled'

  try {
    const data = await impersonate.stop()
    setToken(data.access_token)
    clearImpersonationSession()
    return 'ok'
  } catch {
    return 'stop_failed'
  }
}

/** Platform_owner precisa de sessão para este slug? (sem sessão ou outro restaurante). */
export function needsImpersonationStart(slug: string): boolean {
  if (!isImpersonationActive()) return true
  const session = getImpersonationSession()
  return !session || session.tenant_slug !== slug
}
